module.exports = __webpack_public_path__ + "img/msapplication-icon-144x144.af898288.png";